import useResource from './useResource';

const useAcademyEventSubmission = ({ url }) => {
	const {
		id: eventSubmissionId,
		findMany: findManyEventSubmissions,
		resources: eventSubmissionResources,
		findOne: findEventSubmission,
		resource: eventSubmissionResource,
		...rest
	} = useResource({
		url,
		name: 'event_submission',
		label: 'Event Submission'
	});

	return {
		eventSubmissionId,
		findManyEventSubmissions,
		eventSubmissionResources,
		findEventSubmission,
		eventSubmissionResource,
		...rest
	};
};

export default useAcademyEventSubmission;
